import React, { useState, useMemo, useRef, useEffect } from "react";
import menuDataStore from './menuData.json';
import { MessageCircle, Download, X } from "lucide-react";

// ---------- Helpers: JSON ke alag-alag formats ko normalize karte hain ----------
const getItemName = (item, fallbackIndex) => {
  if (typeof item === 'string') return item;
  const n =
    item?.name ||
    item?.title ||
    item?.dishName ||
    item?.dish_name ||
    item?.dish ||
    item?.itemName ||
    item?.item_name ||
    item?.label ||
    item?.text ||
    '';
  return String(n).trim() || `Item ${fallbackIndex + 1}`;
};

const getItemImage = (item) => {
  if (typeof item === 'string') return '';
  return item?.image || item?.img || item?.imageUrl || item?.image_url || item?.photo || item?.src || '';
};

const normalizeMenu = (menu) => ({
  ...menu,
  categories: (menu.categories || []).map((cat, cIdx) => ({
    ...cat,
    name: cat.name || cat.title || `Category ${cIdx + 1}`,
    // har dish ko UNIQUE id milti hai -> ek select karne par sab select nahi honge
    subItems: (cat.subItems || cat.items || []).map((it, sIdx) => ({
      id: `${cIdx}-${sIdx}`,
      name: getItemName(it, sIdx),
      image: getItemImage(it),
    })),
  })),
});



const New = () => {
  const normalizedMenus = useMemo(
    () => menuDataStore.menus.map(normalizeMenu),
    []
  );


  const [currentMenuId, setCurrentMenuId] = useState(normalizedMenus[0].id);
  const currentMenu = normalizedMenus.find((m) => m.id === currentMenuId);

  const [selectedTier, setSelectedTier] = useState(currentMenu.pricingTiers[0]);

  // itemChoices[catIndex] = [dishId, dishId, ...]
  const [itemChoices, setItemChoices] = useState({});
  // additionalItems[catIndex] = ['custom dish', ...]
  const [additionalItems, setAdditionalItems] = useState({});

  const [currentPageIndex, setCurrentPageIndex] = useState(0);

  const [customInputOpen, setCustomInputOpen] = useState(false);
  const [customText, setCustomText] = useState('');

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [customerName, setCustomerName] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');

  const totalCategories = currentMenu.categories.length;
  const activeCategory = currentMenu.categories[currentPageIndex];

  const maxAllowed = Number(activeCategory.maxSelections) || 1;
  const currentSelections = itemChoices[currentPageIndex] || [];
  const currentAdditionals = additionalItems[currentPageIndex] || [];

  const isComplete = currentSelections.length === maxAllowed;
  const chosenCount = currentMenu.categories.filter(
    (_, idx) =>
      (itemChoices[idx] || []).length > 0 || (additionalItems[idx] || []).length > 0
  ).length;

  // category index + selected ids -> dish names
  const getSelectedNames = (catIdx) => {
    const cat = currentMenu.categories[catIdx];
    const ids = itemChoices[catIdx] || [];
    return ids
      .map((id) => cat.subItems.find((s) => s.id === id)?.name)
      .filter(Boolean);
  };

    const menuTopRef = useRef(null);

useEffect(() => {
  menuTopRef.current?.scrollIntoView({
    behavior: "smooth",
    block: "start",
  });
}, [currentPageIndex]);

  const handleMenuSelect = (menuId) => {
    setCurrentMenuId(menuId);
    const newMenuObj = normalizedMenus.find((m) => m.id === menuId);
    setSelectedTier(newMenuObj.pricingTiers[0]);
    setItemChoices({});
    setAdditionalItems({});
    setCurrentPageIndex(0);
    setCustomInputOpen(false);
  };

  const handleSubItemSelect = (catIdx, dishId, max = 1) => {
    setItemChoices((prev) => {
      const currentSelected = prev[catIdx] || [];

      if (max === 1) {
        // same dish dobara click = unselect, warna sirf wahi 1 select
        if (currentSelected.includes(dishId)) {
          return { ...prev, [catIdx]: [] };
        }
        return { ...prev, [catIdx]: [dishId] };
      }

      if (currentSelected.includes(dishId)) {
        return { ...prev, [catIdx]: currentSelected.filter((i) => i !== dishId) };
      }
      if (currentSelected.length < max) {
        return { ...prev, [catIdx]: [...currentSelected, dishId] };
      }
      return prev;
    });
  };

  const handleAddCustomItem = (catIdx) => {
    if (!customText.trim()) return;
    setAdditionalItems((prev) => {
      const currentAdds = prev[catIdx] || [];
      return { ...prev, [catIdx]: [...currentAdds, customText.trim()] };
    });
    setCustomText('');
    setCustomInputOpen(false);
  };

  const handleRemoveAdditionalItem = (catIdx, itemToRemove) => {
    setAdditionalItems((prev) => {
      const currentAdds = prev[catIdx] || [];
      return { ...prev, [catIdx]: currentAdds.filter((i) => i !== itemToRemove) };
    });
  };

  const handleFinalSubmit = (e) => {
    e.preventDefault();

    const summaryText = currentMenu.categories
      .map((cat, idx) => {
        const selected = getSelectedNames(idx);
        const additional = additionalItems[idx] || [];
        if (selected.length === 0 && additional.length === 0) return null;

        let line = `• *${cat.name}*: ${selected.join(', ')}`;
        if (additional.length > 0) {
          line += `\n  *Additional Items:* ${additional.join(', ')}`;
        }
        return line;
      })
      .filter(Boolean)
      .join('\n\n');

    const whatsappMessage = `Hello Spice Root! New Proposal:\n\n*Client:* ${customerName}\n*Mobile:* ${mobileNumber}\n*Menu:* ${currentMenu.title}\n*Tier:* ${selectedTier.label} (₹${selectedTier.price}/plate)\n\n*Selections:*\n${summaryText}`;

    const whatsappUrl = `https://wa.me/917874343757?text=${encodeURIComponent(whatsappMessage)}`;

    window.open(whatsappUrl, '_blank');
    setIsModalOpen(false);

    setTimeout(() => {
      window.print();
    }, 300);
  };

  return (
    <>
      {/* ================= STRICT SINGLE-PAGE PRINT DOCUMENT ================= */}
      <div className="only-pdf-print">
        <div style={{ padding: '8px 14px', fontFamily: 'Arial, sans-serif', color: '#333', backgroundColor: '#FFF' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderBottom: '2px solid #8B0000', paddingBottom: '8px', marginBottom: '10px' }}>
            <div
              style={{
                position: "relative",
                display: "flex",
                alignItems: "center",
                gap: "12px",
              }}
            >
              {/* Client Logo */}
              <img
                src="/assets/img/logo/1.png"
                alt="Client Logo"
                style={{
                  maxWidth: "180px",
                  maxHeight: "80px",
                  objectFit: "contain",
                }}
              />

              {/* Vegetarian Symbol - Top Right */}
              <img
                src="/assets/img/logo/veg_logo.png"
                alt="Vegetarian"
                style={{
                  position: "absolute",
                  top: "0",
                  right: "0",
                  width: "15px",
                  height: "15px",
                  objectFit: "contain",
                }}
              />
            </div>

            <div style={{ textAlign: 'right' }}>
              <div style={{ fontSize: '15px', fontWeight: 'bold', color: '#8B0000', letterSpacing: '0.5px' }}>CATERING PROPOSAL</div>
              <div style={{ fontSize: '12px', color: '#555' }}>Date: {new Date().toLocaleDateString()}</div>
            </div>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '6px', backgroundColor: '#FAF7F2', padding: '8px 10px', borderRadius: '4px', border: '1px solid #D4B595', marginBottom: '10px', fontSize: '16px' }}>
            <div><b>Client:</b> {customerName || 'Valued Guest'} ({mobileNumber || 'N/A'})</div>
            <div><b>Menu:</b> {currentMenu.title}</div>
            <div><b>Tier:</b> {selectedTier.label} (₹{selectedTier.price}/plate)</div>
          </div>

          <h3 style={{ fontSize: '13px', color: '#8B0000', margin: '0 0 6px 0' }}>Final Menu Selections</h3>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '11px' }}>
            <thead>
              <tr style={{ backgroundColor: '#F3E5D8', textAlign: 'left' }}>
                <th style={{ padding: '6px 10px', border: '1px solid #D4B595', color: '#5C3A21', width: '35%' }}>Category</th>
                <th style={{ padding: '6px 10px', border: '1px solid #D4B595', color: '#5C3A21', width: '65%' }}>Selected Dish Name</th>
              </tr>
            </thead>
            <tbody>
              {currentMenu.categories.map((cat, idx) => {
                const selections = getSelectedNames(idx);
                const additionals = additionalItems[idx] || [];
                const hasSelected = selections.length > 0 || additionals.length > 0;

                return (
                  <tr key={idx}>
                    <td style={{ padding: '6px 10px', border: '1px solid #E6D5C3', fontWeight: 'bold' }}>{cat.name}</td>
                    <td style={{ padding: '6px 10px', border: '1px solid #E6D5C3', color: hasSelected ? '#27ae60' : '#999' }}>
                      {hasSelected ? (
                        <div>
                          {selections.length > 0 && <div>{selections.join(', ')}</div>}
                          {additionals.length > 0 && (
                            <div style={{ fontSize: '14px', color: '#8B0000', marginTop: '2px' }}>
                              <b>Additional:</b> {additionals.join(', ')}
                            </div>
                          )}
                        </div>
                      ) : 'Not Selected'}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>

          <div style={{ marginTop: '12px', textAlign: 'center', fontSize: '14px', color: '#777', borderTop: '1px solid #DDD', paddingTop: '6px' }}>
            Thank you for choosing The Spice Root! | Contact: +91 78743 43757 | thespiceroot.com
          </div>
        </div>
      </div>
      {/* ================= END OF PRINT DOCUMENT ================= */}

      {/* ================= REGULAR WEB SCREEN UI (FULL WIDTH) ================= */}
      <div className="no-print-screen" style={styles.appContainer}>
        <div className="menu-page-header" style={{ textAlign: 'center', borderBottom: '2px solid #8B0000', paddingBottom: '8px', marginBottom: '12px' }}>
          <div className="menu-brand-row" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px' }}>
            <div
              style={{
                position: "relative",
                display: "flex",
                alignItems: "center",
                gap: "12px",
              }}
            >
              {/* Client Logo */}
              <img
                src="/assets/img/logo/1.png"
                alt="Client Logo"
                className="menu-client-logo"
              />

              {/* Vegetarian Symbol - Top Right */}
              <img
                src="/assets/img/logo/veg_logo.png"
                alt="Vegetarian"
                style={{
                  position: "absolute",
                  top: "0",
                  right: "0",
                  width: "15px",
                  height: "15px",
                  objectFit: "contain",
                }}
              />
            </div>

            <div style={{ textAlign: 'left' }}>
              <h2 style={{ color: '#8B0000', margin: '0', fontSize: '20px', fontFamily: 'serif' }}>THE SPICE ROOT</h2>
              <p style={{ fontSize: '10px', color: '#555', margin: '2px 0 0 0' }}>Catering & Events Organizer</p>
            </div>
          </div>
        </div>

        {/* Layout shuru: left = Menu Package + dishes, right = Live Book Pad (ab upar se start hoga) */}
        <div className="menu-layout"  ref={menuTopRef}>
          <div style={styles.bookPagesContainer}>
            <div className="menu-package-header" style={styles.topBar}>
              <div className="menu-package-title-row" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px', textAlign: 'center' }}>
                <h2 style={styles.topTitle}>Menu Package</h2>
                <h2 style={styles.topTitle}>Choose 1 Of {normalizedMenus.length}</h2>
              </div>
              <div style={styles.menuButtonsContainer}>
                {normalizedMenus.map((menu, index) => {
                  const isSelected = menu.id === currentMenuId;
                  return (
                    <button
                      key={menu.id}
                      type="button"
                      onClick={() => handleMenuSelect(menu.id)}
                      style={{
                        ...styles.menuButton,
                        backgroundColor: isSelected ? '#8B0000' : '#FFF8F0',
                        color: isSelected ? '#FFFFFF' : '#5C3A21',
                        borderColor: isSelected ? '#8B0000' : '#D4B595',
                      }}
                    >
                      {/* <div style={{ fontSize: '12px', opacity: 0.8 }}>Menu 0{index + 1}</div> */}
                      <div style={{ fontSize: '14px', fontWeight: 'bold' }}>{menu.title.split('-')[1] || menu.title}</div>
                    </button>
                  );
                })}
              </div>
            </div>

            <div style={{ textAlign: 'center', marginBottom: '10px' }}>
              <span style={styles.badge}>{currentMenu.title}</span>
              <p style={{ fontSize: '12px', color: '#666', margin: '4px 0 0 0' }}>{currentMenu.description}</p>
            </div>

            {currentPageIndex === 0 && (
              <div style={styles.card}>
                <label style={styles.labelBold}>Select Number of Guests & Pricing Tier:</label>
                <div className="guest-tier-grid" style={styles.tierGrid}>
                  {currentMenu.pricingTiers.map((tier, idx) => {
                    const isTierSelected = selectedTier.label === tier.label;
                    return (
                      <button
                        key={idx}
                        type="button"
                        onClick={() => setSelectedTier(tier)}
                        style={{
                          ...styles.tierButton,
                          backgroundColor: isTierSelected ? '#8B0000' : '#FFF8F0',
                          color: isTierSelected ? '#FFFFFF' : '#333333',
                          borderColor: isTierSelected ? '#8B0000' : '#E6D5C3',
                        }}
                      >
                        <div style={{ fontSize: '13px', fontWeight: 'bold' }}>{tier.label} Guests</div>
                        <div style={{ fontSize: '11px', opacity: 0.9 }}>₹{tier.price} / plate</div>
                      </button>
                    );
                  })}
                </div>
              </div>
            )}

            <div style={styles.bookPageCard}>
              <div style={styles.pageHeader}>
                <div>
                  <span style={styles.pageNumberBadge}>Page {currentPageIndex + 1} of {totalCategories}</span>
                  <h3 style={{ margin: '4px 0 0 0', fontSize: '16px', color: '#8B0000' }}>
                    {activeCategory.name} {maxAllowed > 1 ? `(Select up to ${maxAllowed})` : ''}
                  </h3>
                </div>
                <div style={{ fontSize: '12px', fontWeight: 'bold', color: isComplete ? '#27ae60' : '#c0392b' }}>
                  {currentSelections.length > 0 ? `${currentSelections.length}/${maxAllowed} Selected` : `Select ${maxAllowed}`}
                </div>
              </div>

              {/* DISH GRID: image upar, naam niche */}
              <div className="dish-grid" style={styles.subItemGrid}>
                {activeCategory.subItems.length === 0 && (
                  <div style={{ gridColumn: '1 / -1', fontSize: '12px', color: '#777', padding: '10px 0' }}>
                    No fixed dishes in this category. Use the button below to add your own.
                  </div>
                )}

                {activeCategory.subItems.map((subItem) => {
                  const isSelected = currentSelections.includes(subItem.id);
                  return (
                    <div
                      key={subItem.id}
                      onClick={() => handleSubItemSelect(currentPageIndex, subItem.id, maxAllowed)}
                      style={{
                        ...styles.subItemCard,
                        borderColor: isSelected ? '#8B0000' : '#E6D5C3',
                        backgroundColor: isSelected ? '#FFF0F0' : '#FFFFFF',
                      }}
                    >
                      <div style={styles.imageBox}>
                        <span style={styles.imageFallback}>🍽️</span>
                        {subItem.image && (
                          <div
                            role="img"
                            aria-label={subItem.name}
                            style={{ ...styles.imageLayer, backgroundImage: `url("${subItem.image}")` }}
                          />
                        )}
                        {isSelected && <div style={styles.selectedBadge}>✓</div>}
                      </div>
                      <div style={styles.itemName} title={subItem.name}>{subItem.name}</div>
                    </div>
                  );
                })}
              </div>

              {!customInputOpen && (
                <button
                  type="button"
                  onClick={() => setCustomInputOpen(true)}
                  style={{
                    width: '100%',
                    marginTop: '10px',
                    padding: '10px',
                    borderRadius: '6px',
                    border: '1px dashed #8B0000',
                    backgroundColor: '#FFF8F0',
                    color: '#8B0000',
                    fontSize: '12px',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                  }}
                >
                  + Add Custom Item for this Category
                </button>
              )}

              {customInputOpen && (
                <div className="custom-item-form" style={{ marginTop: '10px', padding: '8px', backgroundColor: '#FFF8F0', borderRadius: '6px', border: '1px solid #D4B595', display: 'flex', gap: '6px' }}>
                  <input
                    type="text"
                    placeholder="Type custom dish name (e.g. Manchurian Dry)..."
                    value={customText}
                    onChange={(e) => setCustomText(e.target.value)}
                    onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); handleAddCustomItem(currentPageIndex); } }}
                    style={{ flex: 1, padding: '7px', fontSize: '12px', borderRadius: '4px', border: '1px solid #CCC' }}
                  />
                  <button
                    type="button"
                    onClick={() => handleAddCustomItem(currentPageIndex)}
                    style={{ padding: '6px 12px', backgroundColor: '#8B0000', color: '#FFF', border: 'none', borderRadius: '4px', fontSize: '12px', fontWeight: 'bold', cursor: 'pointer' }}
                  >
                    Add
                  </button>
                  <button
                    type="button"
                    onClick={() => setCustomInputOpen(false)}
                    style={{ padding: '6px 10px', backgroundColor: '#DDD', color: '#333', border: 'none', borderRadius: '4px', fontSize: '12px', cursor: 'pointer' }}
                  >
                    Cancel
                  </button>
                </div>
              )}

              {currentAdditionals.length > 0 && (
                <div style={{ marginTop: '10px', padding: '8px 10px', backgroundColor: '#FFF3F3', borderRadius: '6px', border: '1px dashed #8B0000' }}>
                  <div style={{ fontSize: '11px', fontWeight: 'bold', color: '#8B0000', marginBottom: '4px' }}>Additional Custom Items:</div>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                    {currentAdditionals.map((addItem, aIdx) => (
                      <span key={aIdx} style={{ fontSize: '12px', backgroundColor: '#8B0000', color: '#FFF', padding: '3px 8px', borderRadius: '4px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                        {addItem}
                        <span onClick={() => handleRemoveAdditionalItem(currentPageIndex, addItem)} style={{ cursor: 'pointer', fontWeight: 'bold', fontSize: '14px' }}>×</span>
                      </span>
                    ))}
                  </div>
                </div>
              )}

              <div className="page-turn-footer" style={styles.pageTurnFooter}>
                <button
                  type="button"
                  disabled={currentPageIndex === 0}
                  onClick={() => { setCurrentPageIndex((prev) => Math.max(0, prev - 1)); setCustomInputOpen(false); }}
                  style={{ ...styles.pageTurnButton, opacity: currentPageIndex === 0 ? 0.4 : 1 }}
                >
                  ← Previous Page
                </button>
                <span style={{ fontSize: '12px', fontWeight: 'bold', color: '#5C3A21' }}>{currentPageIndex + 1} / {totalCategories}</span>
                <button
                  type="button"
                  disabled={currentPageIndex === totalCategories - 1}
                  onClick={() => { setCurrentPageIndex((prev) => Math.min(totalCategories - 1, prev + 1)); setCustomInputOpen(false); }}
                  style={{ ...styles.pageTurnButton, opacity: currentPageIndex === totalCategories - 1 ? 0.4 : 1 }}
                >
                  Next Page →
                </button>
              </div>
            </div>
          </div>

          {/* ================= RIGHT SIDEBAR: Live Book Pad (bada kiya) ================= */}
          <div className="menu-sidebar" style={styles.sidebarTracker}>
            <div style={styles.sidebarHeader}>
              <h3 style={{ margin: 0, fontSize: '16px', color: '#8B0000' }}>Live Book Pad</h3>
              <span style={{ fontSize: '13px', backgroundColor: '#8B0000', color: '#FFF', padding: '3px 10px', borderRadius: '6px', fontWeight: 'bold' }}>
                {chosenCount}/{totalCategories} Done
              </span>
            </div>

            <div style={styles.sidebarPriceBox}>
              <div style={{ fontSize: '13px', color: '#666' }}>Tier: <b>{selectedTier.label}</b></div>
              <div style={{ fontSize: '16px', fontWeight: 'bold', color: '#8B0000' }}>₹{selectedTier.price} / plate</div>
            </div>

            <div style={styles.sidebarList}>
              {currentMenu.categories.map((cat, idx) => {
                const chosenNames = getSelectedNames(idx);
                const additionals = additionalItems[idx] || [];
                const hasChosen = chosenNames.length > 0 || additionals.length > 0;
                const isCurrentPage = currentPageIndex === idx;

                return (
                  <div
                    key={idx}
                    onClick={() => { setCurrentPageIndex(idx); setCustomInputOpen(false); }}
                    style={{
                      ...styles.sidebarItemRow,
                      borderColor: isCurrentPage ? '#8B0000' : '#EADCC9',
                      backgroundColor: isCurrentPage ? '#FFF0F0' : '#FAF7F2',
                      cursor: 'pointer',
                    }}
                  >
                    <div style={{ fontSize: '13px', color: '#8B5A2B', fontWeight: 'bold' }}>
                      P.{idx + 1} {cat.name}
                    </div>
                    <div style={{ fontSize: '13px', color: hasChosen ? '#27ae60' : '#999', fontWeight: 'bold', marginTop: '3px', lineHeight: 1.35 }}>
                      {hasChosen ? (
                        <div>
                          {chosenNames.length > 0 && <div>✓ {chosenNames.join(', ')}</div>}
                          {additionals.length > 0 && (
                            <div style={{ color: '#8B0000', fontSize: '12px', marginTop: '2px' }}>
                              + Additional: {additionals.join(', ')}
                            </div>
                          )}
                        </div>
                      ) : '— Pending'}
                    </div>
                  </div>
                );
              })}
            </div>

            <button
              type="button"
              onClick={() => setIsModalOpen(true)}
              style={styles.sidebarActionButton}
            >
              Download PDF / Share Menu
            </button>
          </div>
        </div>

        {isModalOpen && (
          <div style={styles.modalOverlay}>
            <div style={styles.modalContent}>
              <h3 style={{ marginTop: 0, color: '#8B0000', fontSize: '16px' }}>Enter Your Details</h3>
              <p style={{ fontSize: '11px', color: '#666', marginBottom: '12px' }}>
                Enter your details to send this menu proposal directly to our WhatsApp and print your PDF.
              </p>

              <form onSubmit={handleFinalSubmit}>
                <div style={{ marginBottom: '10px', textAlign: 'left' }}>
                  <label style={styles.modalLabel}>Full Name</label>
                  <input
                    type="text"
                    required
                    value={customerName}
                    onChange={(e) => setCustomerName(e.target.value)}
                    style={styles.modalInput}
                    placeholder="e.g. Rajesh Patel"
                  />
                </div>

                <div style={{ marginBottom: '15px', textAlign: 'left' }}>
                  <label style={styles.modalLabel}>Mobile Number</label>
                  <input
                    type="tel"
                    required
                    value={mobileNumber}
                    onChange={(e) => setMobileNumber(e.target.value)}
                    style={styles.modalInput}
                    placeholder="e.g. 7458596641"
                  />
                </div>

                <div
                  style={{
                    display: "flex",
                    gap: "8px",
                    width: "100%",
                    alignItems: "center",
                  }}
                >
                  {/* Cancel Button */}
                  <button
                    type="button"
                    onClick={() => setIsModalOpen(false)}
                    style={{
                      ...styles.cancelButton,
                      flex: 1,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "6px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <X size={17} />
                    Cancel
                  </button>

                  {/* WhatsApp Button */}
                  <button
                    type="submit"
                    style={{
                      ...styles.submitButton,
                      flex: 1.5,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "6px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <MessageCircle size={18} />
                    Share WhatsApp
                  </button>

                  {/* Download / Print Button */}
                  <button
                    type="button"
                    onClick={() => {
                      setIsModalOpen(false);
                      setTimeout(() => {
                        window.print();
                      }, 300);
                    }}
                    style={{
                      ...styles.skipButton,
                      flex: 1,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "6px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <Download size={17} />
                    Download
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>

      <style>{`
        .only-pdf-print {
          display: none !important;
        }
          .menu-layout {
  scroll-margin-top: 15px;
}

        /* Left = dishes, Right = Live Book Pad (ab bada: 400px) */
        .menu-layout {
          display: grid;
          grid-template-columns: minmax(0, 1fr) 480px;
          gap: 20px;
          align-items: start;
        }

        @media (max-width: 1100px) {
          .menu-layout {
            grid-template-columns: minmax(0, 1fr) 400px;
          }
        }

        @media (max-width: 900px) {
          .menu-layout {
            grid-template-columns: minmax(0, 1fr);
          }
          .menu-sidebar {
            position: static !important;
            width: 100%;
          }
        }

        /* ================= RESPONSIVE TABLET ================= */
        .no-print-screen, .no-print-screen * {
          box-sizing: border-box;
        }

        .no-print-screen {
          max-width: 100%;
          overflow-x: clip;
        }

        .menu-layout > * {
          min-width: 0;
        }

        .dish-grid {
          grid-template-columns: repeat(auto-fill, minmax(135px, 1fr)) !important;
        }

        @media (max-width: 768px) {
          .no-print-screen {
            padding: 10px 12px !important;
          }

          .menu-page-header {
            padding-bottom: 10px !important;
            margin-bottom: 10px !important;
          }

          .menu-brand-row {
            flex-wrap: wrap;
            gap: 8px !important;
          }

          .menu-client-logo {
            width: min(42vw, 150px);
            max-width: 150px;
            height: auto;
            object-fit: contain;
          }

          .menu-brand-row h2 {
            font-size: 17px !important;
          }

          .menu-brand-row p {
            font-size: 10px !important;
          }

          .menu-layout {
            grid-template-columns: minmax(0, 1fr) !important;
            gap: 14px !important;
          }

          .menu-package-header {
            padding: 10px !important;
          }

          .menu-package-title-row {
            align-items: flex-start;
            gap: 8px;
          }

          .menu-package-title-row h2 {
            font-size: 13px !important;
          }

          .menu-package-header > div:nth-child(2) {
            display: flex !important;
            flex-wrap: nowrap;
            overflow-x: auto;
            -webkit-overflow-scrolling: touch;
            gap: 7px !important;
          }

          .menu-package-header > div:nth-child(2) > button {
            flex: 0 0 auto !important;
            min-width: 105px !important;
            font-size: 12px !important;
            padding: 10px 8px !important;
          }

          .guest-tier-grid {
            grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
            gap: 8px !important;
          }

          .guest-tier-grid button {
            min-height: 48px;
          }

          .dish-grid {
            grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
            gap: 8px !important;
            min-height: 0 !important;
            max-height: none !important;
            overflow: visible !important;
            padding-right: 0 !important;
          }

          .dish-grid > div {
            min-width: 0;
          }

          .dish-grid > div > div:first-child {
            height: 92px !important;
          }

          .dish-grid > div[style] {
            padding: 6px !important;
          }

          .page-turn-footer {
            gap: 8px;
            flex-wrap: wrap;
          }

          .page-turn-footer button {
            padding: 9px 10px !important;
            font-size: 11px !important;
          }

          .menu-sidebar {
            padding: 12px !important;
          }

          .menu-sidebar > div:nth-child(2) {
            gap: 8px;
            flex-wrap: wrap;
          }

          .menu-sidebar > div:nth-child(2) > div {
            min-width: 0;
          }

          .menu-sidebar > div:nth-child(2) > div:last-child {
            font-size: 14px !important;
          }

          .menu-sidebar > div:nth-child(3) {
            max-height: 360px !important;
            min-height: 0 !important;
          }

          .menu-sidebar > div:nth-child(3) > div {
            padding: 10px !important;
          }

          .menu-sidebar > div:nth-child(3) > div > div {
            overflow-wrap: anywhere;
          }

          .custom-item-form {
            flex-wrap: wrap;
          }

          .custom-item-form input {
            flex: 1 1 100%;
            min-width: 0;
          }

          .custom-item-form button {
            flex: 1;
          }
        }

        /* ================= SMALL MOBILE ================= */
        @media (max-width: 420px) {
          .no-print-screen {
            padding: 8px !important;
          }

          .menu-brand-row {
            gap: 6px !important;
          }

          .menu-client-logo {
            width: 118px;
          }

          .menu-brand-row h2 {
            font-size: 15px !important;
          }

          .menu-brand-row p {
            font-size: 9px !important;
          }

          .menu-package-title-row h2 {
            font-size: 12px !important;
          }

          .dish-grid {
            grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
            gap: 7px !important;
          }

          .dish-grid > div[style] {
            padding: 5px !important;
          }

          .dish-grid > div > div:first-child {
            height: 82px !important;
          }

          .dish-grid img,
          .dish-grid [role="img"] {
            max-width: 100%;
          }

          .page-turn-footer {
            display: grid !important;
            grid-template-columns: 1fr auto 1fr;
          }

          .page-turn-footer button:last-child {
            justify-self: end;
          }

          .menu-sidebar > div:first-child {
            align-items: flex-start !important;
            gap: 8px;
          }

          .menu-sidebar > div:first-child h3 {
            font-size: 14px !important;
          }

          .menu-sidebar > div:first-child span {
            font-size: 11px !important;
          }
        }

        @media print {
          body * {
            visibility: hidden !important;
          }

          .only-pdf-print, .only-pdf-print * {
            visibility: visible !important;
          }

          @page {
            size: A4 portrait;
            margin: 6mm;
          }

          body, html {
            background-color: #FFFFFF !important;
            margin: 0 !important;
            padding: 0 !important;
            height: 100% !important;
            overflow: hidden !important;
          }

          .only-pdf-print {
            display: block !important;
            position: absolute !important;
            left: 0 !important;
            top: 0 !important;
            width: 100% !important;
            background: #FFFFFF !important;
            z-index: 999999 !important;
          }

          .only-pdf-print table { display: table !important; width: 100% !important; }
          .only-pdf-print tr { display: table-row !important; }
          .only-pdf-print th, .only-pdf-print td { display: table-cell !important; }
        }
      `}</style>
    </>
  );
};

const IMAGE_HEIGHT = '120px'; // sab dish images ki same height, yahan se change karo

const styles = {
  appContainer: { width: '100%', margin: '0', padding: '12px 24px', boxSizing: 'border-box', fontFamily: 'Arial, sans-serif' },
  topBar: { backgroundColor: '#FFFFFF', padding: '10px 15px', borderRadius: '10px', border: '1px solid #EADCC9', marginBottom: '12px' },
  topTitle: { margin: '2px 0 8px 0', fontSize: '16px', color: '#222' },
  menuButtonsContainer: { display: 'flex', gap: '8px', overflowX: 'auto', paddingBottom: '4px' },
  menuButton: { flex: '1', minWidth: '95px', padding: '8px 6px', borderRadius: '6px', border: '1px solid', cursor: 'pointer', textAlign: 'center' },

  bookPagesContainer: { padding: '2px', minWidth: 0 },

  badge: { display: 'inline-block', padding: '2px 10px', borderRadius: '12px', backgroundColor: '#F3E5D8', color: '#5C3A21', fontSize: '16px', fontWeight: 'bold' },
  card: { backgroundColor: '#FFFFFF', padding: '10px 12px', borderRadius: '8px', border: '1px solid #EADCC9', marginBottom: '10px' },
  labelBold: { display: 'block', fontSize: '12px', fontWeight: 'bold', color: '#333', marginBottom: '6px' },

  tierGrid: { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '6px' },
  tierButton: { padding: '6px', borderRadius: '6px', border: '1px solid', cursor: 'pointer', textAlign: 'center' },

  bookPageCard: { backgroundColor: '#FFFFFF', border: '1px solid #D4B595', borderRadius: '10px', padding: '14px' },
  pageHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', borderBottom: '1px solid #EADCC9', paddingBottom: '6px', marginBottom: '10px' },
  pageNumberBadge: { fontSize: '11px', backgroundColor: '#F3E5D8', color: '#5C3A21', padding: '1px 6px', borderRadius: '4px', fontWeight: 'bold' },

  subItemGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))',
    gridAutoRows: 'max-content',
    alignContent: 'start',
    gap: '12px',
    minHeight: '260px',
    maxHeight: 'calc(100vh - 340px)',
    overflowY: 'auto',
    paddingRight: '4px',
  },
  subItemCard: { padding: '8px', borderRadius: '8px', border: '2px solid', cursor: 'pointer', textAlign: 'center', display: 'flex', flexDirection: 'column', boxSizing: 'border-box' },

  imageBox: { position: 'relative', width: '100%', height: IMAGE_HEIGHT, borderRadius: '6px', overflow: 'hidden', backgroundColor: '#F3E5D8', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 },
  imageFallback: { fontSize: '28px', opacity: 0.5 },
  imageLayer: { position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' },
  selectedBadge: { position: 'absolute', top: '6px', right: '6px', width: '22px', height: '22px', borderRadius: '50%', backgroundColor: '#27ae60', color: '#FFF', fontSize: '12px', fontWeight: 'bold', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '2px solid #FFF' },
  itemName: { marginTop: '8px', minHeight: '34px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', fontSize: '13px', color: '#333', lineHeight: 1.25, wordBreak: 'break-word' },

  pageTurnFooter: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '12px', paddingTop: '8px', borderTop: '1px solid #EADCC9' },
  pageTurnButton: { backgroundColor: '#F3E5D8', color: '#5C3A21', border: '1px solid #D4B595', padding: '8px 14px', borderRadius: '6px', fontSize: '12px', fontWeight: 'bold', cursor: 'pointer' },

  // Sidebar: bada padding, bade fonts, tall list
  sidebarTracker: { backgroundColor: '#FFFFFF', border: '1px solid #D4B595', borderRadius: '10px', padding: '16px', position: 'sticky', top: '15px', boxSizing: 'border-box' },
  sidebarHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #EADCC9', paddingBottom: '8px', marginBottom: '10px' },
  sidebarPriceBox: { backgroundColor: '#FFF8F0', padding: '10px 12px', borderRadius: '8px', border: '1px solid #E6D5C3', marginBottom: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  sidebarList: { maxHeight: 'calc(100vh - 300px)', minHeight: '240px', overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '12px', paddingRight: '4px' },
  sidebarItemRow: { padding: '10px 12px', borderRadius: '8px', border: '1px solid' },
  sidebarActionButton: { backgroundColor: '#8B0000', color: '#FFFFFF', border: 'none', padding: '12px', borderRadius: '8px', fontSize: '14px', fontWeight: 'bold', cursor: 'pointer', width: '100%' },

  modalOverlay: { position: 'fixed', top: '0', left: '0', width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 },
  modalContent: { backgroundColor: '#FFFFFF', padding: '18px', borderRadius: '10px', width: '100%', maxWidth: '340px', textAlign: 'center' },
  modalLabel: { display: 'block', fontSize: '10px', fontWeight: 'bold', textTransform: 'uppercase', color: '#555', marginBottom: '3px' },
  modalInput: { width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #CCC', fontSize: '12px', boxSizing: 'border-box' },
  cancelButton: { flex: 1, padding: '6px', borderRadius: '6px', border: '1px solid #CCC', backgroundColor: '#F5F5F5', color: '#333', fontWeight: 'bold', cursor: 'pointer', fontSize: '12px' },
  submitButton: { flex: 1, padding: '6px', borderRadius: '6px', border: 'none', backgroundColor: '#8B0000', color: '#FFF', fontWeight: 'bold', cursor: 'pointer', fontSize: '12px' },
  skipButton: { width: '100%', padding: '6px', borderRadius: '6px', border: '1px dashed #8B0000', backgroundColor: '#FFF8F0', color: '#8B0000', fontWeight: 'bold', cursor: 'pointer', fontSize: '11px', marginTop: '4px' },
};

export default New;




